<template>
  <div>
    <iframe
      :src="externalLink"
      referrerpolicy="origin"
      width="100%"
      height="1000px"
      style="border: none;"
    ></iframe>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Pilotage Planning",
  data() {
    return {
      externalLink: 'https://pilotage-planning.bunkerchain.io/',
    };
  },
  computed: {
    ...mapState(["userInfo","screenType"]),
    isMobileScreen(){
      return this.screenType?.isMobileScreen??false;
    },
  },
  created() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.dev-container {
  border-radius: 10px;
  height: calc(100vh - 90px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  color: #49464f;
}
</style>
